import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { homeApi } from '../api/home';
import BottomNav from '../components/BottomNav';
import Navbar from '../components/Navbar';
import Icon from '../components/Icon';
import './Login.css';

const Login = () => {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState('');
  const [code, setCode] = useState('');
  const [sendIng, setSendIng] = useState(false);
  const [showInterval, setShowInterval] = useState(0);
  const [intervalTime, setIntervalTime] = useState(60);
  const [agreed, setAgreed] = useState(false);
  const [isWechatBrowser, setIsWechatBrowser] = useState(false);
  const [configInfo, setConfigInfo] = useState({});

  useEffect(() => {
    checkWechatBrowser();
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      const result = await homeApi.getConfig();
      if (result.code === 200 || result.code === 1) {
        const config = result.data.data?.config || result.data.config || {};
        setConfigInfo(config);
      }
    } catch (error) {
      console.error('获取配置失败:', error);
    }
  };

  const checkWechatBrowser = () => {
    const ua = navigator.userAgent.toLowerCase();
    setIsWechatBrowser(ua.indexOf('micromessenger') !== -1);
  };

  const startInterval = () => {
    setShowInterval(intervalTime);
    const timer = setInterval(() => {
      setShowInterval(prev => {
        if (prev <= 1) {
          setSendIng(false);
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const sendCode = async () => {
    if (sendIng) return;

    if (!/^1[3-9]\d{9}$/.test(mobile)) {
      alert('手机号码格式错误');
      return;
    }

    setSendIng(true);
    startInterval();

    try {
      const result = await homeApi.sendSms({ mobile, event: 'mobilelogin' });
      if (result.code === 200) {
        alert('验证码已发送，请注意查收');
      } else {
        alert(result.msg || '发送失败');
        setSendIng(false);
      }
    } catch (error) {
      console.error('发送验证码失败:', error);
      alert('发送失败');
      setSendIng(false);
    }
  };

  const handleLogin = async () => {
    if (!agreed) {
      alert('请先同意协议和政策');
      return;
    }

    if (!mobile) {
      alert('手机号码不能为空');
      return;
    }

    if (!code) {
      alert('验证码不能为空');
      return;
    }

    try {
      const result = await homeApi.mobileLogin({
        mobile,
        code,
        platform: 'H5'
      });

      console.log('登录结果:', result);

      if (result.code === 200 || result.code === 1) {
        const token = result.data.login_token || result.data.token;
        localStorage.setItem('token', token);
        
        // 保存用户信息
        const userInfo = result.data.user_info || result.data.userinfo;
        if (userInfo) {
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
        }
        
        alert('登录成功');
        setTimeout(() => {
          navigate('/profile');
        }, 500);
      } else {
        alert(result.msg || '登录失败');
      }
    } catch (error) {
      console.error('登录失败:', error);
      alert('登录失败');
    }
  };

  const wechatLogin = () => {
    window.location.href = '/member/wechat/login';
  };

  const goBack = () => {
    navigate(-1);
  };

  const goHome = () => {
    navigate('/');
  };

  return (
    <div className="login-page">
      <Navbar showBack={false} showHome={false} />

      <div className="login-container">
        <div className="logo-section">
          <img src={configInfo.home_logo || '/logo.png'} alt="Logo" className="logo" />
        </div>

        <div className="form-group">
          <div className="form-label">
            手机号<span className="required">*</span>
          </div>
          <div className="form-input-wrapper">
            <input
              type="text"
              maxLength={11}
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="请输入手机号"
              className="form-input"
            />
          </div>
        </div>

        <div className="form-group">
          <div className="form-label">
            验证码<span className="required">*</span>
          </div>
          <div className="form-input-wrapper code-input-wrapper">
            <input
              type="text"
              maxLength={4}
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="请输入验证码"
              className="form-input"
            />
            <div
              className={`send-code-btn ${sendIng ? 'sending' : ''}`}
              onClick={sendCode}
            >
              {sendIng ? `重新获取(${showInterval})` : '获取验证码'}
            </div>
          </div>
        </div>

        <button 
          className="submit-btn" 
          onClick={handleLogin}
          style={{ background: configInfo.zhusediao || '#1890ff' }}
        >
          登录
        </button>

        {isWechatBrowser && (
          <div className="wechat-login-section">
            <div className="divider">
              <span className="divider-text">其他登录方式</span>
            </div>
            <button className="wechat-login-btn" onClick={wechatLogin}>
              <Icon type="weixin" className="wechat-icon" />
              <span>微信一键登录</span>
            </button>
          </div>
        )}

        <div className="agreement-section">
          <label className="agreement-checkbox">
            <input
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
            />
            <span>同意</span>
          </label>
          <div className="agreement-links">
            <span onClick={() => navigate('/about?id=27')} className="agreement-link">
              用户注册协议
            </span>
            <span onClick={() => navigate('/about?id=31')} className="agreement-link">
              隐私保护政策
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
